// #region Imports
import PropTypes from "prop-types"
import React, { useEffect, useMemo, useState } from "react"
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css"
import ContribuyentesComponent from "../../components/Common/ContribuyentesComponent"
import ContribuyentesInsert from "../../components/Common/ContribuyentesInsert"

// #region reactstrap
import {
  Container,
  Col,
  Row,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  Input,
  FormFeedback,
  Label,
  Card,
  CardBody,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Badge,
  Button,
} from "reactstrap"
// #endregion
import Spinners from "components/Common/Spinner"
import { Link } from "react-router-dom"

// #region  components
import Breadcrumbs from "../../components/Common/Breadcrumb"
// #endregion

//redux
import { useDispatch } from "react-redux"

import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

//i18n
import { withTranslation } from "react-i18next"

// #endregion

// #region selectors
import { useCampusVirtualIdCampus } from "store/selectors"
// #endregion

// #region actions
import { setControlEscolarListaEstados as setsListaIdStatus } from "store/actions"
// #endregion

const Contribuyentes = props => {
  //meta title
  document.title = "Contribuyentes | CampusVirtual"
  //
  // #region Init

  // #endregion

  // #region const-selectors
  // #endregion

  // #region useRef

  // #endregion

  // #region react-redux
  const dispatch = useDispatch()
  // #endregion

  // #region Internal States
  const [showModalInsertRFC, setModalInsertRFC] = useState(false)
  // #endregion

  // #region useEffects

  // #endregion

  // #region functions
  const toggleModalInsertRfc = () => {
    setModalInsertRFC(!showModalInsertRFC)
  }
  // #endregion

  // #region formik

  // #endregion

  // #region Options

  // #endregion

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            title={props.t("Altas, Bajas y Cambios")}
            breadcrumbItem={props.t("Contribuyentes")}
          />
          {/* DocumentosListado */}
          <Modal isOpen={showModalInsertRFC}>
            <ModalBody>
              <ContribuyentesInsert />
            </ModalBody>
            <ModalFooter>
              <button
                className="btn btn-primary"
                data-bs-target="#firstmodal"
                onClick={toggleModalInsertRfc}
              >
                Cerrar
              </button>
            </ModalFooter>
          </Modal>

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <ContribuyentesComponent />
                </CardBody>
              </Card>
            </Col>
          </Row>
          <button
            className="btn btn-primary"
            data-bs-target="#firstmodal"
            onClick={toggleModalInsertRfc}
          >
            Abrir
          </button>
        </Container>
      </div>
    </React.Fragment>
  )
}

Contribuyentes.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
}

export default withTranslation()(Contribuyentes)
